import Vue from "vue";
import CONFIG from "./../../config.js";

let actions = {
  setUserEmail (context, value) {
    context.commit("SET_USER_EMAIL", value);
  },
  setWaitTime (context, value) {
    context.commit("SET_WAIT_TIME", value);
  },
  setWaitMessage (context, value) {
    context.commit("SET_WAIT_MESSAGE", value);
  },
  mobile (context, params) {
    context.commit("addLog", { request: "mobile" });
    context.commit("SET_SIGNUP_MOBILE", params.mobile)
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(CONFIG.getEndpoint("mobile"), params, { withCredentials: true })
        .then(response => {
          context.commit("removeLog", { request: "mobile" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("removeLog", { request: "mobile" });
          reject(err.response);
        });
    });
  },
  mobileResend (context) {
    context.commit("addLog", { request: "mobile" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .put(CONFIG.getEndpoint("mobile"), undefined, { withCredentials: true })
        .then(response => {
          context.commit("removeLog", { request: "mobile" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("removeLog", { request: "mobile" });
          reject(err.response);
        });
    });
  },
  loginVerify (context, params) {
    context.commit("addLog", { request: "loginVerify" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(CONFIG.getEndpoint("loginVerify"), params, {
          withCredentials: true
        })
        .then(response => {
          context.commit("SET_WAIT_TIME", response.data.waitTime);
          context.commit("SET_WAIT_MESSAGE", response.data.waitMessage);
          if (response.data.signupStatus === "PROFILE_COMPLETE") {
            context.commit("setLoginState", true);
          }
          context.commit("removeLog", { request: "loginVerify" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("removeLog", { request: "loginVerify" });
          reject(err.response);
        });
    });
  },
  signupVerify (context, params) {
    context.commit("addLog", { request: "signupVerify" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(CONFIG.getEndpoint("signupVerify"), params, {
          withCredentials: true
        })
        .then(response => {
          context.commit("SET_WAIT_TIME", response.data.waitTime);
          context.commit("SET_WAIT_MESSAGE", response.data.waitMessage);
          context.commit("removeLog", { request: "signupVerify" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("removeLog", { request: "signupVerify" });
          reject(err.response);
        });
    });
  },
  personal_details (context, params) {
    context.commit("addLog", { request: "personal_details" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(CONFIG.getEndpoint("personal_details"), params, {
          withCredentials: true
        })
        .then(response => {
          context.commit("SET_USER_EMAIL", response.data.email);
          context.commit("removeLog", { request: "personal_details" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("removeLog", { request: "personal_details" });
          reject(err.response);
        });
    });
  },
  employment_details (context, params) {
    context.commit("addLog", { request: "employment_details" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(CONFIG.getEndpoint("employment_details"), params, {
          withCredentials: true
        })
        .then(response => {
          context.commit("removeLog", { request: "employment_details" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("removeLog", { request: "employment_details" });
          reject(err.response);
        });
    });
  },
  email (context, params) {
    context.commit("addLog", { request: "email" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(CONFIG.getEndpoint("email"), params, { withCredentials: true })
        .then(response => {
          context.commit("removeLog", { request: "email" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("removeLog", { request: "email" });
          reject(err.response);
        });
    });
  },
  emailResend (context) {
    context.commit("addLog", { request: "email" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .put(CONFIG.getEndpoint("email"), undefined, { withCredentials: true })
        .then(response => {
          context.commit("removeLog", { request: "email" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("removeLog", { request: "email" });
          reject(err.response);
        });
    });
  },
  verify_email_otp (context, params) {
    context.commit("addLog", { request: "verify_email_otp" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(CONFIG.getEndpoint("verify_email_otp"), params, {
          withCredentials: true
        })
        .then(response => {
          context.commit("removeLog", { request: "verify_email_otp" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("removeLog", { request: "verify_email_otp" });
          reject(err.response);
        });
    });
  },
  signup_status (context) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(CONFIG.getEndpoint("signup_status"), { withCredentials: true })
        .then(response => {
          if (response.data.email) {
            context.commit("SET_USER_EMAIL", response.data.email);
          }
          if (response.data.userSignupStatus === "PROFILE_COMPLETE") {
            context.commit("setLoginState", true);
          } else {
            context.commit("setLoginState", false);
          }
          context.commit("SET_SIGNUP_STATUS", response.data);
          resolve(response.data);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  register_emandate (context, params) {
    context.commit("addLog", { request: "register_emandate" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(CONFIG.getEndpoint("register_emandate"), params, {
          withCredentials: true
        })
        .then(response => {
          context.commit("removeLog", { request: "register_emandate" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("removeLog", { request: "register_emandate" });
          reject(err.response);
        });
    });
  },
  emandate_methods (context) {
    context.commit("addLog", { request: "emandate_methods" });
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(CONFIG.getEndpoint("emandate_methods"), { withCredentials: true })
        .then(response => {
          context.commit("removeLog", { request: "emandate_methods" });
          resolve(response.data);
        })
        .catch(err => {
          context.commit("removeLog", { request: "emandate_methods" });
          reject(err.response);
        });
    });
  },
  resolveSignupRoute (context, state) {
    return new Promise((resolve, reject) => {
      switch (state) {
        case "NOT_REGISTERED":
          resolve({ routeName: "Personal Details" });
          break;
        case "V1_REGISTERED":
          resolve({ routeName: "Personal Details" });
          break;
        case "PROFILE_COMPLETE":
          context.dispatch('getUser')
            .then((response) => {
              response.version === 'epaylaterv2' ?
                resolve({ routeName: "Dashboard" }) :
                resolve({ routeName: "Home" })
              context.commit("setLoginState", true);
            })
            .catch(() => { reject(new Error("User not logged in")) })
          break;
        case "V4_CREDIT_LIMIT_PENDING":
          resolve({ routeName: "Loading" })
          break;
        case "V2_REGISTERED_EMAIL_VERIFICATION_PENDING":
          resolve({ routeName: "Verify Email OTP" });
          break;
        case "V4_REGISTERED_EMAIL_VERIFICATION_PENDING":
          resolve({ routeName: "Verify Email OTP" });
          break;
        case "V4_REGISTERED_EMPLOYMENT_NOT_REQUIRED":
          resolve({ routeName: "Verify Email OTP" });
          break;
        case "V4_REGISTERED_EMPLOYMENT_PENDING":
          resolve({ routeName: "Employment Details" });
          break;
        default:
          reject(new Error("Unknown State Found"));
          break;
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/store/signup/actions.js